
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OurServiceDashboard from './OurServiceDashboard/OurServiceDashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* / route */}
        <Route
          path="/"
          element={
            <div>
              <OurServiceDashboard />
            </div>
          }
        />

       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
